import { Outlet, useParams, useLocation } from "react-router-dom";
import Sidebar from "../components/partials/Sidebar";

const AppLayout = () => {
    const { categoryId } = useParams();
    const currentRoute = useLocation().pathname;
    let resolvedCategoryId;
    if (currentRoute === "/starter") {
        resolvedCategoryId = -2;
    } else if (currentRoute === "/news") {
        resolvedCategoryId = -3;
    } else {
        resolvedCategoryId = categoryId ?? -1;
    }
    return (
        <div className="flex justify-end">
            <Outlet />
            <Sidebar categoryId={resolvedCategoryId} />
        </div>
    )
};

export default AppLayout;